import { menuItemsData, publicMenuItems  } from "../menuItemsData.js";
import MenuItems from "./MenuItems";
import { useAuth } from '../routes/MyContextProvider';

const Navbar = () => {
  const { isLoggedIn } = useAuth();
  const depthLevel = 0;

  return (
    <nav className="desktop-nav">
      <ul className="menus">
		{isLoggedIn 
          ? menuItemsData.map((menu, index) => (
              <MenuItems items={menu} key={index} depthLevel={depthLevel} />
            ))
          : publicMenuItems.map((menu, index) => (
              <MenuItems items={menu} key={index} depthLevel={depthLevel} />
            ))
        }
      </ul>
    </nav>
  );
};

export default Navbar;
